module.exports = __webpack_public_path__ + "static/img/bg-top-02.e6899ce.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bg-top-02.png
// module id = 1r0G
// module chunks = 1